import {isMaintanceStatusCode} from "@/src/shared/utils/maintanceError/isMaintanceStatusCode";
import {MAINTANCE_ERROR} from "@/src/shared/const";

const throwMaintanceError = (error: Error) => {
    const isMaintanceError = isMaintanceStatusCode(error);

    if (isMaintanceError) {
        throw new Error(MAINTANCE_ERROR);
    }
}

export { throwMaintanceError }
